import axios from "axios";
import t  from "../../languages/es/global.json"
import { createMsgToast, doLogout } from "../../store/globalSlice";
import {store} from "../../store/store"
import { CODE_AUTH_EXPIRED, CODE_MULTI_FACTOR_AUTH } from "../globalConstants";

export async function apiFetch({
  method,
  url, 
  params = null,
  data = null, 
  contentType = "application/json",
  headerParams = true,
  api = process.env.REACT_APP_API,
  successMsg = null,
  originApp = false
  }) {

  const lang = localStorage.getItem("language") || "es"
  const token = localStorage.getItem("token")
  const user = localStorage.getItem("user")
  const rol = localStorage.getItem("rol")
  const header = {
    "Content-Type": contentType,
    ...(headerParams ? {
      'Authorization': 'Bearer '+token,
      ...(originApp ? { "originApp": process.env.REACT_APP_ORIGIN_APP } : { 'originUser': user, 'originUserRole': rol }),
      "Accept-Language": lang,
    } : {})
  }

  try {
    let response
    response = await axios({
      method: method,
      url: api+url,
      ...(params ? {params : params} : {}),
      ...(data ? {data : data} : {}),
      headers: header,
    });

    if (response.data) {
      if(successMsg) {
        store.dispatch(createMsgToast({body: successMsg, variant:"positive"}))
      }
      return response.data;
    }
  } catch (error) {
    let errorFormat = error
    if(error.code === "ERR_NETWORK" || error.code === 403){
      store.dispatch(doLogout())
      errorFormat = {
        response: error.name,
        message: error.message
      }
    }
    if (error.response) {
      if (error.response.status === 422 || error.response.status === 401) {
        store.dispatch(doLogout())
        errorFormat = {
          response: error.code,
          message: error.response.data.message === "token.invalidExpired" ? t.errors.tokenExpired : error.response.data.message
        };
      }
      if (error.response.status === 404) {
        window.location.href = "/not-found";
      }
      if(error.response.status === 409){
        errorFormat = {
          response: error.name,
          message:error.response.data.message
        }
      }
      if (error.response.status === 400 && data.message.includes(CODE_MULTI_FACTOR_AUTH)){
        errorFormat = {
          response: error.code,
          message: t.errors.multiFactorAuth
        };
      }
      if (error.response.status === 400 && data.message.includes(CODE_AUTH_EXPIRED)){
        errorFormat = {
          response: error.code,
          message: t.errors.codeAuthExpired
        };
        const cleanUrl = window.location.protocol + "//" + window.location.host + window.location.pathname;
        window.history.replaceState({}, document.title, cleanUrl);
      }
    }
    store.dispatch(createMsgToast({body: errorFormat.message, title:"Error", variant:"negative"}))
  }
}